import { Pressable, View } from 'react-native'

import { styled } from '~/core/styled'

export const Container = styled(Pressable, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',

      overflow: 'hidden',

      gap: theme.spacingInlineOnepulse,

      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorFormsBorderDefault,
      borderRadius: theme.borderRadiusForm,

      paddingVertical: theme.spacingStackOnepulse,
      paddingHorizontal: theme.paddingInsetThreepulse,

      backgroundColor: theme.colorFormsFillDefault,
    },

    variants: {
      size: {
        md: {
          minHeight: theme.sizingMedium,
          paddingVertical: theme.paddingInsetNone,
        },
        ml: {
          minHeight: theme.sizingMediumlarge,
        },
        lg: {
          minHeight: theme.sizingLarge,
        },
        xl: {
          minHeight: theme.sizingExtralarge,
          borderRadius: theme.borderRadiusLargecontainer,
        },
      },
      isFocused: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          // @TODO: Update with new tokens - (theme.colorFormsBorderFocused)
          borderColor: 'rgba(0, 0, 0, 1)',

          backgroundColor: theme.colorFormsFillFocused,
        },
      },
      isFilled: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderFilled,

          backgroundColor: theme.colorFormsFillFilled,
        },
      },
      isError: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderError,

          backgroundColor: theme.colorFormsFillDefault,
        },
      },
      isDisabled: {
        true: {
          borderColor: theme.colorFormsBorderDisabled,
          borderWidth: theme.borderWidthQuarterpulse,

          backgroundColor: theme.colorFormsFillDisabled,
        },
      },
      isReadOnly: {
        true: {
          borderColor: theme.colorFormsBorderReadonly,
          borderWidth: theme.borderWidthQuarterpulse,

          backgroundColor: theme.colorFormsFillReadonly,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isFocused: true,
          isFilled: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          // @TODO: Update with new tokens - (theme.colorFormsBorderFocused)
          borderColor: 'rgba(0, 0, 0, 1)',
        },
      },
      {
        variants: {
          isFocused: true,
          isError: true,
        },
        css: {
          borderWidth: theme.borderWidthHalfpulse,
          backgroundColor: theme.colorFormsFillFocused,
        },
      },
      {
        variants: {
          isFilled: true,
          isError: true,
        },
        css: {
          backgroundColor: theme.colorFormsFillError,
        },
      },
    ],
  }
})

export const ContainerChosenOptions = styled(View, theme => {
  return {
    base: {
      flex: 1,

      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacingInlineTwopulse,

      paddingVertical: theme.paddingInsetOnepulse,
    },
  }
})

export const Interactions = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineOnepulse,
    },
  }
})

export const ClearButton = styled(View, theme => {
  return {
    base: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
        },
        ml: {
          height: theme.sizingMediumlarge,
        },
        lg: {
          height: theme.sizingMediumlarge,
        },
        xl: {
          height: theme.sizingMediumlarge,
        },
      },
    },
  }
})
